import script from "./SeasonStandings.vue?vue&type=script&setup=true&lang=js"
export * from "./SeasonStandings.vue?vue&type=script&setup=true&lang=js"

import "./SeasonStandings.vue?vue&type=style&index=0&id=3cc84906&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/set-repository-web-glasses/glasses-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cc84906"]])

export default __exports__